import React, { memo } from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

interface LegacyMetricGaugeProps {
    valueText: string;
    colorIndex: number;
    metricOmitted?: boolean;
    value?: number;
    target?: number;
    metricAttained?: boolean;
}

// Isolated on purpose: this is the pre-existing gauge used everywhere in the app today (My
// Metrics, CAP session view, etc). Nothing in this file is shared with TieredMetricGauge - not
// even a constant name - so a future change to the tiered gauge's sizing/stroke can never bleed
// into this one again the way STROKE_WIDTH once did when both lived in one file.
const LEGACY_STROKE_WIDTH = 15;

export const LegacyMetricGauge = memo(({
    valueText,
    colorIndex,
    metricOmitted,
    value,
    target,
    metricAttained,
}: LegacyMetricGaugeProps) => {
    const gradientIndex = metricOmitted ? 5 : colorIndex;

    let cTextColor = '#C90370';
    if (metricOmitted) {
        cTextColor = '#3F5765';
    } else if (metricAttained) {
        cTextColor = '#2AA154';
    }

    return (
        <CircularProgressbar
            maxValue={target}
            styles={buildStyles({
                textColor: cTextColor,
                pathColor: `url(#gradientId${gradientIndex})`,
                trailColor: metricAttained ? `url(#gradientId${gradientIndex})` : '#E0E0E0',
                pathTransition: 'none',
            })}
            value={value ?? 0}
            text={valueText}
            strokeWidth={LEGACY_STROKE_WIDTH}
        />
    );
});
LegacyMetricGauge.displayName = 'LegacyMetricGauge';

export default LegacyMetricGauge;
